const YesNo = [
    {id: "0", value: "是"},    
    {id: "1", value: "不是"}
  ];  
  
  export default YesNo